import React from 'react';

const StockStatus = ({ data }) => (
    <div className="delivery-status" title={data.hoverText}>
        <span className="delivery-status__icon" style={{ backgroundColor: data.color }}></span> <span className="delivery-status__name">{data.text}</span>
    </div>
)


export default StockStatus;